<template>
  <el-dialog :visible.sync="visible"
             :title="$t('privateNetInstance.bindTitle')"
             :close-on-click-modal="false"
             :before-close="handleClose" class="bind-dialog">
    <el-alert :title="$t('privateNetInstance.chooseBindTip', [instanceName])"
              type="info"
              :closable="false">
    </el-alert>
    <el-table :data="flexPublicNetList"
              style="width: 100%;"
              max-height="242"
              class="bind-flex-net">
      <el-table-column label="" min-width="16">
        <template scope="scope">
          <el-radio v-model="radioVal"
                    :label="scope.$index">
            {{ '' }}
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="elasticIp"
                       :label="$t('privateNetInstance.tableTitle.ip')">
        <template scope="scope">
          <span>{{ scope.row.elasticIp }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bandwidth"
                       :label="$t('privateNetInstance.tableTitle.bandWidth')">
        <template scope="scope">
          <span>{{ scope.row.bandwidth.toString() | withColon('Mbps') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="region"
                       :label="$t('privateNetInstance.tableTitle.region')">
        <template scope="scope">
          <span>{{ transformRegion(scope.row.region) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="cancelBind">
        {{ $t('privateNetInstance.cancel') }}
      </el-button>
      <el-button @click="sureBind"
                 type="primary"
                 :disabled="radioVal === '' || loading"
                 :loading="loading">
        {{ $t('privateNetInstance.bindSure') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BindFlexNet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    instanceName: {
      type: String,
      default: ''
    },
    region: {
      type: String,
      default: ''
    },
    instanceId: {
      type: String,
      default: ''
    },
    loadBalancerId: {
      type: String,
      default: ''
    },
    // 负载均衡实例绑定IP的时候没有这个提示
    isSLB: {
      type: Boolean,
      default: false
    },
    // SLB负载均衡实例和另外两种实例绑定EIP调用接口不同
    isSlb: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flexPublicNetList: [],
      radioVal: '',
      bindIP: {},
      loading: false, // 添加loading状态
    };
  },
  methods: {
    transformRegion(region) {
      switch (region) {
        default:
          return this.$t('eip.text.allAz');
      }
    },
    handleClose() {
      this.radioVal = '';
      this.bindIP = {};
      this.$emit('update:visible', false);
    },
    cancelBind() {
      this.handleClose();
    },
    sureBind() {
      // 防止重复点击
      if (this.loading) return;
      
      this.loading = true;
      
      const params = {
        region: this.region,
        elasticIpId: this.bindIP.elasticIpId
      };
      let tempParams = {}
      let url = ''
      if (this.isSlb) {
        tempParams = Object.assign(params, {loadBalancerId: this.loadBalancerId,})
        url = '/api/cps/slbs/associateElasticIp'
      } else {
        tempParams = Object.assign(params, {instanceId: this.instanceId,})
        url = '/api/cps/associateElasticIp'
      }

      Ajax.put(url, tempParams)
        .then((res) => {
          // this.$message.success(this.$t('privateNetInstance.operateSuccess'));
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally(() => {
          this.handleClose();
          this.$emit('refresh');
          // 延迟重置loading状态，确保弹窗完全关闭后再重置
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    getFlexPublicNetList() {
      const params = {
        region: this.region,
        status: 'disassociate',
        pageSize: 1000
      };
      Ajax.get('/api/cps/listElasticIps', params)
        .then((res) => {
          this.flexPublicNetList = res.data.elasticIps.filter(item => item.charge.chargeStatus === 'normal');
        })
        .catch(async (err) => {
          const {response} = err.data;
          try {
            const json = await response.json();
            target.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally();
    },
  },
  watch: {
    radioVal(newVal, oldVal) {
      if (newVal !== '') {
        this.bindIP = this.flexPublicNetList[newVal];
      }
    }
  },
  created() {
    this.getFlexPublicNetList();
  }
};
</script>

<style lang="scss">
  .bind-dialog {
    .el-alert {
      padding: 5px 8px;
      margin: 0 0 20px;
      .el-alert__title {
        word-break: break-all !important;
      }
    }

    .el-alert--info {
      background-color: #fff4e5;
      border-color: #ff9600;
      color: #ff9600;
    }

    .bind-flex-net {
      .el-radio {
        .el-radio__label {
          padding-left: 0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/privateNetInstance/bindFlexNet/BindFlexNet.vue